import clsx from "classnames";
import { Description, Title } from "@/ui";
import CTA from "@/ui/CTA";
import classes from "../styles.module.scss";

/**
 * Text side of the CTA banner: optional tag pill, heading, rich text and buttons.
 *
 * @param {boolean} [showTag] - Whether to render the tag pill.
 * @param {string} [tagText] - Tag pill text.
 * @param {string} [title] - Heading text.
 * @param {string} [description] - Rich text HTML.
 * @param {Array} [buttons] - Button items.
 * @param {boolean} [twoColList] - Render lists in the description across two columns.
 * @param {boolean} [fullWidth] - Let the text span the full card (text-only mode).
 * @returns {JSX.Element}
 */
export default function CTAContent({ showTag, tagText, title, description, buttons = [], twoColList, fullWidth }) {
  return (
    <div className={clsx(classes.ctaBanner__content, { [classes["ctaBanner__content--full"]]: fullWidth })}>
      {showTag && !!tagText && (
        <div className={classes.ctaBanner__tag} data-sourceflow-prop="tagText">
          {tagText}
        </div>
      )}

      <Title title={title} tag="h2" className="mb-4" />

      <div data-sourceflow-prop="description" className={clsx({ [classes["ctaBanner__description--twoCol"]]: twoColList })}>
        <Description description={description} />
      </div>

      {!!buttons.length && (
        <div data-sourceflow-prop="button" className={classes.ctaBanner__buttons}>
          {buttons.map((btn, k) => (
            <CTA
              key={k}
              label={btn.label}
              href={btn.href}
              variant={btn.variant || "tertiary"}
              target={btn.open_in_new_tab ? "_blank" : undefined}
            />
          ))}
        </div>
      )}
    </div>
  );
}
